import {
  PlatformCheckoutPayload,
  PlatformCheckoutSessionResponse,
  PlatformInvoicesParams,
  PlatformInvoicesResponse,
  PlatformPaymentStatus,
  PlatformPaymentStatusResponse,
} from 'src/types';
import axios, { ENDPOINTS } from 'src/utils/axios';

export const getPlatformInvoices = async (params: PlatformInvoicesParams) => {
  const response = await axios.get<PlatformInvoicesResponse>(ENDPOINTS.app.subscription.invoices, {
    params,
  });

  return response.data;
};

export const createPlatformCheckout = async (payload: PlatformCheckoutPayload) => {
  const response = await axios.post<PlatformCheckoutSessionResponse>(
    ENDPOINTS.app.subscription.checkout,
    payload
  );

  return response.data;
};

export const getPlatformPaymentStatus = async (paymentId: PlatformPaymentStatus['payment_id']) => {
  const response = await axios.get<PlatformPaymentStatusResponse>(
    `${ENDPOINTS.app.subscription.payments}/${paymentId}`
  );

  return response.data;
};
